import React, { createContext, useMemo, useState } from "react";
import { Button, Header, Icon } from "semantic-ui-react";
import { Rnd } from "react-rnd";
import { Styles } from "../../../res";

const { f_16_700_text } = Styles;

export const FreeModalContext = createContext();

const FreeModal = ({
    title,
    onClose,
    open,
    children,
    fileKey,
    closeButton,
    headerColor = "#dcdddd",
    headerTextColor = "black",
    isNeg = true,
    onMouseDown = () => { }
}) => {

    const top = useMemo(() => Math.ceil(Math.random() * 200) + 5, []);
    const left = useMemo(() => Math.floor(Math.random() * 300) + 5, []);

    const [size, setSize] = useState({ width: 700, height: 500 });
    const [position, setPosition] = useState(() =>
        isNeg
            ? { x: left, y: top }
            : {
                x: (window.innerWidth - 600) / 2,
                y: (window.innerHeight - 400) / 2,
            }
    );

    if (!open || open === 0) return null;

    return (
        <Rnd
            onMouseDown={onMouseDown}
            default={isNeg ? {
                width: size.width,
                height: size.height,
                x: left,
                y: top,
            } : {
                x: (window.innerWidth - 600) / 2,
                y: (window.innerHeight - 400) / 2,
                width: 600,
                height: 400,
            }}
            bounds="body"
            className="tw-flex tw-flex-col tw-h-full tw-w-full tw-fixed tw-z-[90]"
            size={{ width: size.width, height: size.height }}
            position={position}
            dragHandleClassName="free-modal-handle"
            onDragStop={(e, data) => {
                setPosition({ x: data.x, y: data.y });
            }}
            onResize={(e, direction, ref, delta, position) => {
                setSize({
                    width: ref.offsetWidth,
                    height: ref.offsetHeight,
                });
                setPosition(position);
            }}
            style={{ zIndex: open || 0, background: "white", border: "solid 1px #ccc", }}
        >

            {/* Header (drag handle) */}
            <div
                className="free-modal-handle"
                style={{
                    padding: 5,
                    cursor: "move",
                    zIndex: 10,
                    backgroundColor: headerColor,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    height: "49px"
                }}
            >
                <div>
                    <Header style={{ ...f_16_700_text, color: headerTextColor }}>
                        {title}
                    </Header>
                </div>

                <div>
                    {closeButton ? (
                        <Button
                            size="small"
                            {...closeButton}
                            onClick={() =>
                                onClose((prev) => {
                                    const temp = { ...prev };
                                    delete temp[fileKey];
                                    return temp;
                                })
                            }
                        />
                    ) : (
                        <Icon
                            link
                            name="x"
                            onClick={() =>
                                onClose((prev) => {
                                    const temp = { ...prev };
                                    delete temp[fileKey];
                                    return temp;
                                })
                            }
                        />
                    )}
                </div>
            </div>

            <div style={{ borderTop: "solid 1px #ccc" }} />

            {/* Contents */}
            <div className="tw-flex-1 tw-overflow-auto tw-h-[90%] tw-w-full tw-p-5">
                <FreeModalContext.Provider value={size.width}>
                    {children}
                </FreeModalContext.Provider>
            </div>
        </Rnd>
    );
};

export default FreeModal;
